import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import Avatar from '../../../../shared/library/avatars/avatar';
import LoadMoreButton from '../../buttons/load-more';

const Conatiner = glamorous.div({
  display: 'block'
});

const AvatarContainer = glamorous.div({
  gridTemplateColumns: 'repeat(auto-fill, 64px)',
  justifyContent: 'space-between',
  gridGap: 20,
  display: 'grid',
  textAlign: 'center'
});

const Center = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 25
});

const Faces = ({users, hasNextPage, loading, loadMore, isMobile}) => {
  return (
    <Conatiner>
      <AvatarContainer>
        {users.map(user => (
          <Avatar key={user.id} user={user} withPopover={isMobile ? false : true} />
        ))}
      </AvatarContainer>
      {hasNextPage && (
        <Center>
          <LoadMoreButton loading={loading} onClick={loadMore} />
        </Center>
      )}
    </Conatiner>
  );
};

Faces.propTypes = {
  users: PropTypes.array,
  hasNextPage: PropTypes.bool,
  loading: PropTypes.bool,
  loadMore: PropTypes.func,
  isMobile: PropTypes.bool
};

export default Faces;
